import { DateTime } from 'luxon'
import { getShortDate, getTime } from '@utils/dateUtils'

export const NOTIFY_ME_LABEL = 'Notify Me'

const parseAcceptsFlag = (value) => value === true || value === 'true'

export function isRegistrationNotOpenYet(event, now = DateTime.now()) {
  const { registrationOpenDateTime, timezone } = event
  if (!registrationOpenDateTime) {
    return false
  }
  const zone = timezone || 'UTC'
  const openAt = DateTime.fromISO(registrationOpenDateTime, { zone })
  if (!openAt.isValid) {
    return false
  }
  return openAt > now.setZone(zone)
}

export function showRegistrationOpenNotification(event) {
  return (
    isRegistrationNotOpenYet(event)
    && event.acceptsRegistrationOpenNotifications
    && !event.isCanceled
    && !event.registrationClosed
    && !event.externalRegistrationUrl
  )
}

export function showRegistrationOpensInfoOnly(event) {
  return (
    isRegistrationNotOpenYet(event)
    && !event.acceptsRegistrationOpenNotifications
    && !event.isCanceled
    && !event.registrationClosed
    && !event.externalRegistrationUrl
  )
}

export function shouldShowRegistrationOpensLine(event) {
  return (
    isRegistrationNotOpenYet(event)
    && Boolean(event.registrationOpenDateTime)
    && !event.isCanceled
    && !event.registrationClosed
  )
}

/**
 * GROUP_EVENTS often omits `accepts_registration_open_notifications`. Coach Tools GraphQL
 * exposes it as a computed field (true while `registrationOpenDateTime` is in the future).
 * When Algolia omits the attribute, mirror that so journey cards match event detail.
 */
export function resolveAcceptsRegistrationOpenNotifications(rawValue, event = {}) {
  if (rawValue !== undefined && rawValue !== null && rawValue !== '') {
    return parseAcceptsFlag(rawValue)
  }
  if (event.isCanceled) {
    return false
  }
  return isRegistrationNotOpenYet(event)
}

export function formatRegistrationOpensCaption(registrationOpenDateTime, timezone) {
  if (!registrationOpenDateTime) return null
  const eventTimezone = timezone || 'UTC'
  return `Registration opens ${getShortDate(registrationOpenDateTime, eventTimezone)} at ${getTime(registrationOpenDateTime, eventTimezone)}`
}

export function buildInternalRegistrationUrl({ slug, source }) {
  const base = `${process.env.MY_PGA_COM_URL}/things-to-do/events/${slug}/register`
  if (typeof source !== 'string' || source === '') return base
  return `${base}?${new URLSearchParams({ source }).toString()}`
}

export function getGroupEventOfferingListCtaLabel(offering) {
  if (offering.registrationFull && offering.hasWaitlist) {
    return 'Join Waitlist'
  }
  if (showRegistrationOpenNotification(offering)) {
    return NOTIFY_ME_LABEL
  }
  return offering.ctaLabel || 'Register'
}
